import type { User } from 'src/services/apollo/generated/graphql'
import type { OpenSignModalEventData, SignModalProps } from './types'

export type { OpenSignModalEventData, SignModalProps } from './types'

export async function openSignModal(
  props?: SignModalProps | null,
  eventData?: OpenSignModalEventData,
) {
  const { openSignModalRAC } =
    await import('src/components/Account/SignModalRAC')
  openSignModalRAC(props, eventData)
}

/**
 * Determine whether user has email verified
 * or signed up with an OAuth provider
 * @param user
 * @returns whether user is verified
 */
export function isUserVerified(user?: User) {
  return user?.verificationStatus != null
}
